import { render, staticRenderFns } from "./soldApartments.vue?vue&type=template&id=3ebe13de&"
import script from "./soldApartments.vue?vue&type=script&lang=js&"
export * from "./soldApartments.vue?vue&type=script&lang=js&"
import style0 from "./soldApartments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports